import type { DefaultConfigOptions } from '@formkit/vue'
import { generateClasses } from '@formkit/themes'
import { ToggleInput } from '~/formkit/Toggle'
import { ColorPicker } from '~/formkit/Color'
import { MultiSelect } from '~/formkit/MultiSelect'
import { makeRadioOrCheckboxInput } from '~/formkit/RadioCheckbox'
import { AutoCompleteType } from '~/formkit/AutoComplete'

const config: DefaultConfigOptions = {
  inputs: {
    toggle: ToggleInput,
    color: ColorPicker,
    multiple: MultiSelect,
    checkbox: makeRadioOrCheckboxInput(),
    radio: makeRadioOrCheckboxInput(),
    autocomplete: AutoCompleteType,
  },
  iconLoaderUrl: (iconName) =>
    `https://unpkg.com/ionicons@7.1.0/dist/svg/${iconName}.svg`,
  config: {
    classes: generateClasses({}),
  },
}

export default config
